import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';
import { AppFeatureDims, AppFeatureKey } from '@nk/data-entities-lib';
import { NO_ACCESS_ROUTE } from '@nk/utils-lib';
import { map } from 'rxjs/operators';
import { AppFeatureService } from '../services/app-feature.service';

function hasAllRequiredFeatures(availableFeatureKeys: string[], requiredFeatures: AppFeatureKey[]): boolean {
  const flags = availableFeatureKeys.reduce((res: AppFeatureDims['flags'], key) => {
    res[key] = true;
    return res;
  }, {});
  if (flags && Array.isArray(requiredFeatures)) {
    return requiredFeatures.every((i) => flags[i]);
  } else {
    return false;
  }
}

export function featureAccessGuard(requiredFeatures: AppFeatureKey[]): CanActivateFn {
  return (route, state) => {
    const router = inject(Router);
    const appFeatureService = inject(AppFeatureService);
    const translateService = inject(TranslateService);

    return appFeatureService.appFeatureListByMembershipCache.get().pipe(
      map((availableFeatures) => {
        const availableFeatureKeys = availableFeatures.map((a) => a.app_feature_key);
        if (Array.isArray(requiredFeatures) && hasAllRequiredFeatures(availableFeatureKeys, requiredFeatures)) {
          return true;
        }
        const title = translateService.instant(extractTranslation('features.no_access_modal.title')) as string;
        const message = translateService.instant(extractTranslation('features.no_access_modal.message'), {
          url: state.url,
        }) as string;
        void router.navigate([NO_ACCESS_ROUTE], { queryParams: { title, message } });
        return false;
      }),
    );
  };
}
